import { CatalogCard } from "../components/CatalogCard";
import { GameDefinition } from "./gameDefinitons";

export function GameCard({
  game,
  to,
  heading
}: {
  game: GameDefinition;
  to: string;
  heading?: "h2" | "h3";
}) {
  const tags = [
    game.originalLanguage,
    game.originalFramework,
    game.originalYear
  ].filter((tag): tag is string => Boolean(tag));
  return (
    <CatalogCard
      heading={heading}
      title={game.title}
      description={game.summary ?? game.desc}
      image={game.image}
      tags={tags}
      to={to}
      testId="game-card"
    />
  );
}
